/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: block;
}

:host([hidden]) {
  display: none;
}`;
export { style };
